const userLanguage = window.navigator.language || window.navigator.userLanguage
export const DEFAULT_LANGUAGE = userLanguage
